import { InputAnswer, Step } from '../components'
import type { InputQuestionValues } from '../typings'
import type { StepProps } from './StepProps'

const PROFESSIONAL_ORG: InputQuestionValues = {
  key: 'professional_organization',
  trackingKey: 'organization',
  question: `What's your organization's name?`
}

export const ProfessionalStep = (props: StepProps) => {
  return (
    <Step
      index={props.index}
      surveyKey={PROFESSIONAL_ORG.key}
      trackingKey={PROFESSIONAL_ORG.trackingKey}
      title={PROFESSIONAL_ORG.question}
    >
      <InputAnswer
        surveyKey={PROFESSIONAL_ORG.key}
        question={PROFESSIONAL_ORG.question}
        placeholder='Mote Technologies'
        text='Organization Name'
      />
    </Step>
  )
}
